import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-responsive-ui/style.css'
import { Button, Modal, TextInput, FileUpload } from 'react-responsive-ui'
import User from '../menu/user';
import { sendPostFromUser } from '../../helpers/registrationHelper';

class NewPost extends Component {

  constructor(props) {
    super(props);
    this.props = props
    this.state = {}
    this.handleNewPost = this.handleNewPost.bind(this)
    this.handleSendPost = this.handleSendPost.bind(this)
    this.handleSendPostWithImage = this.handleSendPostWithImage.bind(this)
    this.handleNewLinkPost = this.handleNewLinkPost.bind(this)
    this.handleSendURLPost = this.handleSendURLPost.bind(this)
  }

  handleSendPost() {
    if (this.state.newPost) {
      sendPostFromUser({ text: this.state.newPost })
        .then((response) => {
          if (!response.data.error) {
            const { savePost } = this.props;
            savePost(response.data)
            this.setState({ showTextModal: false, newPost: null, newPostEmpty: false })
          } else {
            console.log('posted message incorrectly')
          }
        })
    } else {
      this.setState({ newPostEmpty: true })
    }
  }

  handleSendURLPost() {
    if (this.state.newLinkPost) {
      sendPostFromUser({ text: this.state.newPost, link: this.state.newLinkPost })
        .then((response) => {
          if (!response.data.error) {
            const { savePost } = this.props;
            savePost(response.data)
            this.setState({ showURLModal: false, newPost: null, newLinkPost: null, newPostURLEmpty: false })
          } else {
            console.log('posted message incorrectly')
          }
        })
    } else {
      this.setState({ newPostURLEmpty: true })
    }
  }

  handleSendPostWithImage() {
    if (this.state.file) {
      var data = new FormData()
      data.append('file', this.state.file, this.state.file.fileName)

      sendPostFromUser({ text: this.state.newPost, photo: this.state.picture })
        .then((response) => {
          if (!response.data.error) {
            const { savePost } = this.props;
            savePost(response.data)
            this.setState({ showImageModal: false, newPost: '', newImageEmpty: false })
          } else {
            console.log('posted message incorrectly')
          }
        })
    } else {
      this.setState({ newImageEmpty: true })
    }
  }


  render() {
    return (
      <div className="new-post-container">
        <User {...this.props} user_id={localStorage.getItem('user_id')} />
        <div>
          <div className="header">
            SHARE HOW YOU FEEL TODAY, PHOTO, VIDEO OR IDEA
          </div>
          <div className="button-container">
            <Button action={() => this.setState({ showTextModal: true })}>
              MOOD/ACTIVITIES
              </Button>
            <Button action={() => this.setState({ showImageModal: true })}>
              PHOTO/VIDEO
              </Button>
            <Button action={() => this.setState({ showURLModal: true })}>
              VIDEO LINK
              </Button>
          </div>
        </div>

        <Modal
          className="new-post-modal"
          isOpen={this.state.showTextModal}
          close={() => this.setState({ showTextModal: false, newPostEmpty: false })}>
          <h3>Share your mood and activities</h3>
          <TextInput
            focus
            placeholder="SHARE HOW YOU FEEL TODAY"
            value={this.state.newPost}
            onChange={this.handleNewPost} />
            {this.state.newPostEmpty && <h3 className='post-error'>Text field should not be empty</h3>}
          <Button action={this.handleSendPost}>
            Publish
              </Button>
        </Modal>
        <Modal
          className="new-post-modal"
          isOpen={this.state.showURLModal}
          close={() => this.setState({ showURLModal: false, newPostURLEmpty: false })}>
          <h3>Share a photo or a video</h3>
          <TextInput
            focus
            placeholder="SHARE HOW YOU FEEL TODAY"
            value={this.state.newPost}
            onChange={this.handleNewPost} />
          <TextInput
            value={this.state.newLinkPost}
            placeholder="LINK FOR YOUR VIDEO"
            onChange={this.handleNewLinkPost} />
            {this.state.newPostURLEmpty && <h3 className='post-error'>Text field should not be empty</h3>}
          <Button action={this.handleSendURLPost}>
            Publish
              </Button>
        </Modal>
        <Modal
          className="new-post-modal"
          isOpen={this.state.showImageModal}
          close={() => this.setState({ showImageModal: false, newImageEmpty: false })}>
          <h3>Share a link to a video</h3>
          <TextInput
            placeholder="SHARE HOW YOU FEEL TODAY"
            value={this.state.newPost}
            onChange={this.handleNewPost} />
          {this.state.newImageEmpty && <h3 className='post-error'>Text field should not be empty</h3>}
          <div className="image-preview-wrapper">
            {this.state.file && this.getImageBlock()}
          </div>
          <div className="button-wrapper">
            <Button action={this.handleSendPostWithImage}>
              Publish
            </Button>
            <FileUpload
              action={(file) => this.setState({ file: file })}
              className={`file-upload`}>
              Choose a file
            </FileUpload>
          </div>
        </Modal>
      </div>
    )
  }

  handleNewLinkPost(val) {
    this.setState({ newLinkPost: val })
  }

  getImageBlock() {
    var reader = new FileReader();
    reader.readAsDataURL(this.state.file);
    reader.onload = function () {
      let picture = reader.result
      this.setState({ picture: picture })
    }.bind(this);
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
    return (<img className="image-preview" alt="Preview Image Unavailable" src={this.state.picture} />)
  }

  handleNewPost(val) {
    this.setState({ newPost: val })
  }
}
NewPost.propTypes = {
  history: PropTypes.object,
  savePost: PropTypes.func
};

export default NewPost;



// WEBPACK FOOTER //
// ./src/components/newsline/newPost.js